// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from "react";
// import RoleToggle from "../../components/RoleToggle";
// import InventoryTab from "./_components/InventoryTab"; 
// import ItemInventory from "./_components/ItemInventory";

// const InventoryMangement: React.FC = () => {
//   const roles4 = ["Shipment Inventory", "Items Inventory"];

//   const [activeRole4, setActiveRole4] = useState<string>(
//     () => localStorage.getItem("InventoryActiveRole") || "Shipment Inventory"
//   );

//   useEffect(() => {
//     localStorage.setItem("InventoryActiveRole", activeRole4);
//   }, [activeRole4]);

//   return (
//     <>
//       <div className="space-y-4">
//         <div className="flex justify-between items-center">
//           <RoleToggle
//             options={roles4}
//             active={activeRole4}
//             onChange={setActiveRole4}
//           />
//         </div>
//         {activeRole4 === "Shipment Inventory" && <InventoryTab />}

//         {activeRole4 === "Items Inventory" && (
//           <div className="space-y-4">
//             <ItemInventory />
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default InventoryMangement;


/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import ButtonStyled from "../../components/common/ButtonStyled";
import InventoryTab from "./_components/InventoryTab";
import ItemInventory from "./_components/ItemInventory";
import { useSelector } from "react-redux";
import { selectClientPermissions } from "../../features/auth/authSlice";
import { IconPackage, IconBox } from "@tabler/icons-react";

const INVENTORY_SUB_TABS = [
  {
    label: "Shipment Inventory",
    getComponent: (headerSubTabs: React.ReactNode) => (
      <InventoryTab headerSubTabs={headerSubTabs} />
    ),
    module: "shipment_inventory",
    operation: "read",
    icon: <IconPackage size={18} />,
  },
  {
    label: "Items Inventory",
    getComponent: (headerSubTabs: React.ReactNode) => (
      <ItemInventory headerSubTabs={headerSubTabs} />
    ),
    module: "product_inventory",
    operation: "read",
    icon: <IconBox size={18} />,
  },
];

interface InventoryManagementProps {
  setHeaderButtons?: (n: React.ReactNode) => void;
}

const InventoryMangement: React.FC<InventoryManagementProps> = ({ setHeaderButtons }) => {
  const permissions = useSelector(selectClientPermissions) || [];

  useEffect(() => {
    setHeaderButtons?.(null);
  }, [setHeaderButtons]);

  // 🔐 Filter tabs based on permission
  const allowedTabs = useMemo(() => {
    return INVENTORY_SUB_TABS.filter((tab) =>
      permissions.some(
        (p) =>
          p.module === tab.module &&
          p.operations.includes(tab.operation),
      ),
    );
  }, [permissions]);

  // 🧠 Active tab with persistence
  const [activeRole, setActiveRole] = useState<string>(() => {
    const saved = localStorage.getItem("InventoryActiveRole");
    return saved || allowedTabs[0]?.label;
  });

  // 🔄 Fix active tab if permission changes
  useEffect(() => {
    if (!allowedTabs.find((t) => t.label === activeRole)) {
      setActiveRole(allowedTabs[0]?.label);
    }
  }, [allowedTabs]);

  useEffect(() => {
    if (activeRole) {
      localStorage.setItem("InventoryActiveRole", activeRole);
    }
  }, [activeRole]);

  const activeTab = allowedTabs.find((t) => t.label === activeRole);

  // ⛔ No permission case
  if (allowedTabs.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        No access to Inventory sections
      </div>
    );
  }

  const headerSubTabs = (
    <div className="flex items-center gap-2 flex-wrap">
      {allowedTabs.map((t) => {
        const isActive = activeRole === t.label;
        return (
          <ButtonStyled
            key={t.label}
            onClick={() => setActiveRole(t.label)}
            variant={isActive ? "solid" : "outline"}
            icon={t.icon}
            value={t.label}
          />
        );
      })}
    </div>
  );

  return (
    <div className="w-full flex flex-col p-0" style={{ fontFamily: '"Inter Tight", sans-serif' }}>
      <div className="mt-0">
        {activeTab?.getComponent(headerSubTabs)}
      </div>
    </div>
  );
};

export default InventoryMangement;
